<div class="produtos-container">
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h4>Produtos</h4>
      <div>
        <input type="file" 
               #fileInput 
               style="display: none" 
               accept=".xls,.xlsx"
               (change)="onFileSelected($event)">
        <button class="btn btn-warning" (click)="fileInput.click()">
          <i class="bi bi-upload"></i> Atualizar Estoque .xls/.xlsx
        </button>
      </div>
    </div>
    <div class="card-body">
      <!-- Filtros -->
      <div class="row mb-4">
        <div class="col-md-4">
          <div class="form-group">
            <label>Nome do Produto</label>
            <input type="text" class="form-control" [(ngModel)]="filtroNome" placeholder="Buscar produto...">
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Categoria</label>
            <select class="form-control" [(ngModel)]="filtroCategoria">
              <option value="">Todas</option>
              <option value="Móveis">Móveis</option>
              <option value="Decoração">Decoração</option>
              <option value="Iluminação">Iluminação</option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Status</label>
            <select class="form-control" [(ngModel)]="filtroStatus">
              <option value="">Todos</option>
              <option value="Ativo">Ativo</option>
              <option value="Inativo">Inativo</option>
            </select>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Código</th>
              <th>Nome</th>
              <th>Categoria</th>
              <th>Preço</th>
              <th>Estoque</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let produto of produtos | produtoFilter:filtroNome:filtroCategoria:filtroStatus">
              <td>{{produto.codigo}}</td>
              <td>{{produto.nome}}</td>
              <td>{{produto.categoria}}</td>
              <td>{{produto.preco | currency:'BRL'}}</td>
              <td>{{produto.estoque}}</td>
              <td>
                <span [ngClass]="{
                  'badge': true,
                  'badge-success': produto.status === 'Ativo',
                  'badge-danger': produto.status === 'Inativo'
                }">
                  {{produto.status}}
                </span>
              </td>
              <td>
                <button class="btn btn-primary btn-sm mr-2">
                  <i class="bi bi-eye"></i> Detalhes
                </button>
                <button class="btn btn-warning btn-sm" (click)="openUpdateStockModal(updateStockModal, produto)">
                  <i class="bi bi-arrow-repeat"></i> Atualizar Estoque
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Template do Modal -->
<ng-template #updateStockModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Atualizar Estoque</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>Produto: {{selectedProduct?.nome}}</label>
      <div class="mt-3">
        <label>Quantidade Atual: {{selectedProduct?.estoque}}</label>
        <input type="number" 
               class="form-control mt-2" 
               [(ngModel)]="newStockQuantity" 
               min="0"
               placeholder="Nova quantidade">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="updateStock()">Salvar</button>
  </div>
</ng-template> 